import { render, staticRenderFns } from "./planDetailDc.vue?vue&type=template&id=b45b76e6&scoped=true"
import script from "./planDetailDc.vue?vue&type=script&lang=js"
export * from "./planDetailDc.vue?vue&type=script&lang=js"
import style0 from "./planDetailDc.vue?vue&type=style&index=0&id=b45b76e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45b76e6",
  null
  
)

export default component.exports